// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useProjectsMetadata from './useProjectsMetadata';
import ParamsWithId from 'model/ParamsWithId';
import { UseCase } from '@tls/sw91-communication/types/com.base';

export default function useIsQC(projectId?: string) {
  const { id } = useParams<ParamsWithId>();
  const { selectedProject } = useProjectsMetadata(projectId ?? id);
  const isQC = useMemo(
    () => selectedProject?.projectUseCase?.useCase === UseCase.QUALITY_CHECK,
    [selectedProject?.projectUseCase?.useCase]
  );

  return isQC;
}
